import { useState, useCallback } from "react";
import { getLocalTourPreferences, setLocalTourPreference } from "utils/tourPreferences";
// توابع ذخیره‌سازی را باید از فایل ماک خارج کرده و در یک فایل util عمومی قرار دهید
 
export interface TourStep {
  target: string;
  title: string;
  content: string;
  disableBeacon?: boolean;
}

interface UseTourReturn {
  isActive: boolean;
  currentStep: TourStep | null;
  currentStepIndex: number;
  totalSteps: number;
  startTour: () => void;
  nextStep: () => void;
  prevStep: () => void;
  dismissTour: () => void;
}

// ورودی steps اضافه شد
export const useTour = (tourCode: string, steps: TourStep[] = []): UseTourReturn => {
  
  const isDismissed =
    getLocalTourPreferences().find((p) => p.tourCode === tourCode)
      ?.isDismissed ?? false;

  // وضعیت اولیه تور بر اساس اینکه قبلا بسته شده یا خیر
  const [isActive, setIsActive] = useState(() => !isDismissed && steps.length > 0);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const startTour = useCallback(() => {
    setCurrentStepIndex(0);
    setIsActive(true);
  }, []);

  const nextStep = useCallback(() => {
    setCurrentStepIndex((prev) => {
      const next = prev + 1;
      if (next >= steps.length) {
        setIsActive(false);
        setLocalTourPreference({
          tourCode,
          isDismissed: true,
          lastSeenStep: prev,
          dismissedAt: new Date().toISOString(),
        });
        return prev;
      }
      return next;
    });
  }, [steps.length, tourCode]);

  const prevStep = useCallback(() => {
    setCurrentStepIndex((prev) => Math.max(0, prev - 1));
  }, []);

  const dismissTour = useCallback(() => {
    setIsActive(false);
    setLocalTourPreference({
      tourCode,
      isDismissed: true,
      lastSeenStep: currentStepIndex,
      dismissedAt: new Date().toISOString(),
    });
  }, [tourCode, currentStepIndex]);

  return {
    isActive,
    currentStep: isActive ? (steps[currentStepIndex] ?? null) : null,
    currentStepIndex,
    totalSteps: steps.length,
    startTour,
    nextStep,
    prevStep,
    dismissTour,
  };
};
